/**
 * The words the app has for a name of the domain (a module, a field, an entity); a name it has no words for yet is
 * shown as the domain gives it, so a new one is never a blank.
 */
export function knownText(texts: Record<string, () => string>, name: string): string {
  return (Object.hasOwn(texts, name) ? texts[name]?.() : undefined) ?? name;
}
